import { useState } from 'react';

import { Grid } from '@mui/material';

import { GrupoUsuarioAutoComplete, TipoUsuarioAutoComplete } from 'components/autocompletes';
import { CissTextField, StatusField } from 'components/fields';
import { Filter } from 'components/filter';
import { FilterValuesProps } from 'hooks/useFilter';

export function UsuarioListFilter() {
    const [filterNome, setFilterNome] = useState<FilterValuesProps>({
        property: 'dsUsuario',
        operator: 'like',
        value: null,
        idProperty: 'dsUsuario',
    });

    const [filterEmail, setFilterEmail] = useState<FilterValuesProps>({
        property: 'dsEmail',
        operator: 'like',
        value: null,
        idProperty: 'dsEmail',
    });

    const [filterLogin, setFilterLogin] = useState<FilterValuesProps>({
        property: 'dsLogin',
        operator: 'like',
        value: null,
        idProperty: 'dsLogin',
    });

    const [filterStatus, setFilterStatus] = useState<FilterValuesProps>({
        property: 'fgAtivo',
        operator: 'eq',
        value: null,
        idProperty: 'vlStatus',
    });

    const [filterTipoUsuario, setFilterTipoUsuario] = useState<FilterValuesProps>({
        property: 'idTipoUsuario',
        operator: 'eq',
        value: null,
        idProperty: 'idTipoUsuario',
    });

    const [filterGrupoUsuario, setFilterGrupoUsuario] = useState<FilterValuesProps>({
        property: 'idGrupoUsuario',
        operator: 'in',
        value: [],
        idProperty: 'idGrupoUsuario',
    });

    return (
        <Filter
            preventQueryParamsEmptyStart
            filters={[
                { value: filterNome, setter: setFilterNome },
                { value: filterEmail, setter: setFilterEmail },
                { value: filterLogin, setter: setFilterLogin },
                { value: filterStatus, setter: setFilterStatus },
                { value: filterTipoUsuario, setter: setFilterTipoUsuario },
                { value: filterGrupoUsuario, setter: setFilterGrupoUsuario },
            ]}
        >
            <Grid size={{ lg: 4 }}>
                <CissTextField
                    label="Nome"
                    value={filterNome.value}
                    onChange={(e) => setFilterNome((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
            <Grid size={{ lg: 4 }}>
                <CissTextField
                    label="E-mail"
                    value={filterEmail.value}
                    onChange={(e) => setFilterEmail((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
            <Grid size={{ lg: 4 }}>
                <CissTextField
                    label="Login"
                    value={filterLogin.value}
                    onChange={(e) => setFilterLogin((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
            <Grid size={{ lg: 4 }}>
                <StatusField
                    value={filterStatus.value}
                    onChange={(e, value) => setFilterStatus((oldState: FilterValuesProps) => ({ ...oldState, value }))}
                />
            </Grid>
            <Grid size={{ lg: 4 }}>
                <TipoUsuarioAutoComplete
                    label="Tipo de usuário"
                    disableClearable={false}
                    value={filterTipoUsuario.value}
                    onChange={(e, value) => setFilterTipoUsuario((oldState: FilterValuesProps) => ({ ...oldState, value }))}
                />
            </Grid>
            <Grid size={{ lg: 4 }}>
                <GrupoUsuarioAutoComplete
                    multiple
                    value={filterGrupoUsuario.value}
                    onChange={(e, value) => setFilterGrupoUsuario((oldState: FilterValuesProps) => ({ ...oldState, value }))}
                />
            </Grid>
        </Filter>
    );
}
